import styled from "styled-components";

import Typography from "@anwb/poncho/components/typography";

import { customVariables } from "@topgun/shared-front-end/src/theme/custom-variables";

export const ErrorDetails = styled(Typography).attrs({
  variant: "support-text",
})`
  padding-top: 0.5rem;
  color: ${customVariables.colors.errorDetailsText};
`;
export const SpinnerWrapper = styled.div`
  margin-top: 7rem;
`;
